import { NgModule } from '@angular/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { OutsideClickModule } from '@go-modules/directives/outside-click';

@NgModule({
	imports: [
		GoMaterialModule,
		CommonModule,
		OutsideClickModule
	],
	declarations: [
		MenuComponent
	],
	exports: [
		MenuComponent
	]
})
export class MenuModule {}
